import ThumbnailImage from './ThumbnailImage';

export default ThumbnailImage;
